<template>
	<v-flex >
		<v-data-table 
			:headers="headers"
			:items="occupants"
			hide-actions
			class="PITable"
			>
		  	<template slot="items" slot-scope="props">
				<td>{{ props.item.name }}</td>
				<td>{{ props.item.title }}</td>
<!-- 				<td 
					@click="toggleCurrent(props.item)"
					:style="!props.item.current ? 'color: red;' : 'color: black;'"> 
					{{ props.item.current == true ? 'Yes' : 'No' }}
				</td> -->

				<td class="justify-center  pr-3">
					<v-tooltip left v-if="isSuperUser || isManagerOfRoom(room) || isOccupantEditorOfDept(room.PCT[deptSelectedIndex])">
	              		<v-dialog slot="activator" v-model="removeOccupantDialog[props.index]" persistent max-width="290">
		                
		                	<v-icon slot="activator" small color="red lighten-2">close</v-icon>
		                
			                <v-card class="pl-2 pt-1 pr-2">
						        <v-card-title class="headline">Delete</v-card-title>
						        <v-divider></v-divider>
						        <v-card-text class="pt-4 body-2">Delete {{props.item.name}} from room?</v-card-text>
						        <v-card-actions>
						          	<v-spacer></v-spacer>
						          	<v-btn color="green darken-1" flat @click.native="removeOccupantDialog[props.index] = false">No</v-btn>
						          	<v-btn color="green darken-1" flat 
						          		@click="removeOccupant(props.item, props.index)">Yes
						      	 	 </v-btn>
						        </v-card-actions>
					      	</v-card>
				    	</v-dialog>
		                <span>Delete</span>
		            </v-tooltip>
				</td>
		  	</template>
		  	<template slot="no-data">
				No Occupants
		  	</template>
		</v-data-table>
		<OccupantHistoryDialog :selectedRoom="room" class="ml-2" />
	</v-flex>
</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import OccupantHistoryDialog from '@/components/OccupantHistoryDialog'


export default {
data () {
	return {	removeOccupantDialog: {},
				headers: [
			        { text: 'Name',	align: 'left',	value: 'name' },
			        { text: 'Title', value: 'title' },
			        //{ text: 'Current', value: 'current' },
			        //{ text: '', value: 'name', sortable: false },
			      ],
	}
},

components: { OccupantHistoryDialog, },

computed: {
	...mapState({   	room: 				state => state.dv.room,
						deptSelectedIndex: 	state => state.dv.deptSelectedIndex,
						isSuperUser: state => state.user.isSuperUser,
				}),
	...mapGetters(['allowManagerUI', 'isManagerOfRoom', 'isOccupantEditorOfDept' ]),

	occupants: function () {
		return this.room ? this.room.PCT[this.deptSelectedIndex].occupant : []
	},


},

methods : {
	//...mapMutations([ 						]),

	...mapActions([		'updateOccupant', 'deleteOccupant', 'fetchFullRoom', 'setRoom',
				  ]),

	toggleCurrent: function (occupant) {
		occupant.current = !occupant.current
		this.updateOccupant({ key: occupant.key, current: occupant.current })
	},

	removeOccupant: function (occupant, index) {
		this.deleteOccupant( { 'key': occupant.key } )
		.then(() => {
			this.removeOccupantDialog[index] = false
			this.refreshRoom()
		})		
	},

	refreshRoom: function () {
		this.fetchFullRoom({bldgAlpha: this.room.bldgAlpha, number: this.room.number, noSet: true}).then((data) => this.setRoom(data) )
	}

},
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/RoomViewer/RoomDetailOccupants.vue